import { render, staticRenderFns } from "./TryPerform.vue?vue&type=template&id=6c01e41c&scoped=true"
import script from "./TryPerform.vue?vue&type=script&lang=js"
export * from "./TryPerform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c01e41c",
  null
  
)

export default component.exports